import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';

function InvestmentsSkeleton({ classes }) {
  return (
    <div style={{ marginTop: 8 }}>
      <div className={classes.ths} style={{ display: 'flex' }}>
        {Array(2)
          .fill()
          .map(() => (
            <Skeleton width={128} height={64} style={{ margin: 1 }} />
          ))}
      </div>
      <div style={{ display: 'flex' }}>
        <Skeleton width={128} height={64} style={{ margin: 1 }} />
        <Skeleton width={128} height={64} style={{ margin: 1, marginLeft: 'auto' }} />
      </div>
      <div className={classes.table} style={{ margin: 16 }}>
        <div className={classes.ths} style={{ display: 'flex' }}>
          {Array(9)
            .fill()
            .map(() => (
              <Skeleton className={classes.th} width={128} height={32} style={{ margin: 1 }} />
            ))}
        </div>
        {Array(10)
          .fill()
          .map(() => (
            <Skeleton className={classes.row} height={64} />
          ))}
      </div>
    </div>
  );
}

InvestmentsSkeleton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default InvestmentsSkeleton;
